import React, { useState, useEffect, useRef } from "react";
import t from "../../../../helpers/t";
import {
  messagesActions,
  userActions,
  membershipTypeActions,
  useSelector,
  taskActions,
} from "inbooma-api"; // necessary to communicate with inbooma-react api
import { Biscuit } from "../../../../../utils";
import * as yup from "yup";
import ReactTags from "react-tag-autocomplete";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown } from "@fortawesome/free-solid-svg-icons";
import { faPaperPlane } from "@fortawesome/free-regular-svg-icons";
// necessary to communicate with inbooma-react
import { $, CountryList } from "../../../../../../vendor";
import Editor from "./Editor";
import ScheduleDialog from "./ScheduleDialog";
import UserInput from "../UserInput";
import InboomaSelectBox from "../../../../components/InboomaSelectBox";
import SidebarFilter from "../../../../components/SidebarFilter";

const MessageView = (props) => {
  // initialize message - set selected message or set defaults
  const currentUrl = new URL(window.location.href);
  const isViewMessage = currentUrl.pathname.includes("view");
  const [message, setMessage] = useState(
    props.message === null
      ? {
          client_id: Number(Biscuit.get("user.client_id")),
          subject: "",
          content: "",
          content_for_toast: "",
          recipient: "",
          user_group_id: null,
          notification_type: "",
          recipient_type: "",
          listRecipients: null,
        }
      : {
          ...props.message,
          content:
            props.message.message_data.length > 0 &&
            props.message.message_data[0].m_text !== undefined
              ? props.message.message_data[0].m_text
              : "",
          recipient_type:
            props.message.user_group_id !== null
              ? "userGroup"
              : props.message.recipient !== null
                ? "userID"
                : "allUsers",
          listRecipients:
            props.message.user_group_id !== null
              ? [props.message.user_group_id]
              : props.message.recipient !== null && isViewMessage
                ? [props.message.user_nr]
                : props.message.recipient !== null && !isViewMessage
                  ? props.message.recipient.split(";")
                  : ["all"],
        },
  );

  const reactTags = useRef();
  const [recipients, setRecipients] = useState(
    message.listRecipients !== null ? message.listRecipients : [],
  );
  const [suggestions, setSuggestions] = useState([]);
  const [users, setUsers] = useState(props.users);
  const [userGroups, setUserGroups] = useState([]);
  const _users = useSelector((state) => state.users_data.users);
  const _userGroups = useSelector((state) => state.membership_types_data.membershipTypes);
  const [itemState, setItemState] = useState("init"); // init, pending_tasks, pending_created, pending_modified, ready, saving
  const _sendMessage = useSelector((state) => state.messages_data.sendMessage);
  const _addMessage = useSelector((state) => state.messages_data.addMessage);
  const _editMessage = useSelector((state) => state.messages_data.putMessage);
  const _deleteMessage = useSelector((state) => state.messages_data.deleteMessage);
  const [tags, setTags] = useState(
    props.message === null
      ? []
      : props.message.user_group_id !== null
        ? [
            {
              name: _userGroups.data.filter((item) => item.id === props.message.user_group_id)[0]
                ?.name,
            },
          ]
        : props.message.recipient !== null && isViewMessage
          ? (props.message.mtype === "email"
              ? [props.message.user_nr]
              : props.message.recipient.split(";")
            ).map((recipient) => {
              return {
                name:
                  users.filter((item) => item.id === recipient)[0]?.first_name +
                  " " +
                  users.filter((item) => item.id === recipient)[0]?.last_name,
              };
            })
          : props.message.recipient !== null && !isViewMessage && props.message.mtype === "push"
            ? props.message.recipient.split(";").map((recipient) => {
                return {
                  name:
                    users.filter((item) => item.id === recipient)[0]?.first_name +
                    " " +
                    users.filter((item) => item.id === recipient)[0]?.last_name,
                };
              })
            : [],
  );
  const [formError, setFormError] = useState({});
  //set anchor of dropdown button
  const [showSchedule, setShowSchedule] = useState(false);
  const [toggleDialogSchedule, setToggleDialogSchedule] = useState(false);
  const [checked, setChecked] = useState(
    message.schedule_recurrence_number && message.schedule_recurrence ? true : false,
  );
  const [startDate, setStartDate] = useState(
    message.schedule_time !== undefined ? message.schedule_time : new Date(),
  );
  const [disableButtonSend, setDisableButtonSend] = useState(true);
  const [hiddenChooseRecipient, setHiddenChooseRecipient] = useState(false);
  const [type, setType] = useState(null);

  let initialState = {};

  let language = Biscuit.get("user.lang");
  const lang = Biscuit.get("user.lang").split("_");
  // schema to validate message form
  const messageSchema = yup.object().shape({
    subject: yup.string().required("subject of message is required"),
    recipient_type: yup
      .string()
      .oneOf(
        ["userID", "userGroup", "allUsers"],
        "type of recipient is required and must be one of the following values: userID, userGroup, allUsers",
      )
      .required(),
    notification_type: yup
      .string()
      .oneOf(
        ["toast", "popup"],
        "display of notification is required and must be one of the following values: toast, popup",
      )
      .required(),
    listRecipients: yup
      .array()
      .of(yup.string())
      .required("list of recipients is required")
      .min(1, "list of recipients must have at least 1 item"),
    content: yup.string().required("content of message is required"),
    checkRepeatSchedule: yup.boolean(),
    schedule_recurrence_number: yup.number().positive("must be positive"),
    schedule_recurrence: yup
      .string()
      .oneOf(
        ["day", "week", "month", "year"],
        "schedule recurrence must be one of the following values: day, week, month, year",
      ),
    //   .when("checkRepeatSchedule", {
    //     is: true,
    //     then: yup.number()
    //   })
    //   schedule_recurrence_number: yup.number().when('checkRepeatSchedule', {
    //     is: true,
    //     then: (messageSchema) => messageSchema.positive("Recurrence number of schedule must be positive"),
    //     // .required(t("Recurrence number of schedule is required"))
    //     // .integer("Recurrence number of schedule must be integer"),
    //     otherwise: yup.number().notRequired(),
    //   }),
  });

  const handleChangeCheckRepeat = (event) => {
    setChecked(event.target.checked);
  };

  // handle add and delete recipient field
  const handleDeleteRecipient = (index) => {
    const newTags = tags.slice(0);
    newTags.splice(index, 1);
    const recipientsCopy = recipients.slice(0);
    recipientsCopy.splice(index, 1);
    setRecipients(recipientsCopy);
    setTags(newTags);
  };

  const handleAdditionRecipient = (tag) => {
    const checkTagExisted = tags.filter((item) => item.name === tag.name);
    const inSuggestions = suggestions.filter((suggestion) => suggestion.name === tag.name);
    const typeRecipient = message.recipient_type;
    if (checkTagExisted.length > 0) {
      typeRecipient === "userID"
        ? props.showNotification(
            "warning",
            "",
            t(
              "user ${a} added to recipient field, please add another user",
              { a: t(tag.name) },
              "capital",
            ),
          )
        : props.showNotification(
            "warning",
            "",
            t("you can only send notification to one usergroup"),
          );
    } else if (inSuggestions.length === 0) {
      typeRecipient === "userID"
        ? props.showNotification(
            "warning",
            "",
            t("user ${a} does not exist, please enter a valid user", { a: t(tag.name) }, "capital"),
          )
        : props.showNotification(
            "warning",
            "",
            t(
              "user group ${a} does not exist, please enter a valid user group",
              { a: t(tag.name) },
              "capital",
            ),
          );
    } else if (typeRecipient === "userGroup" && recipients.length > 0) {
      props.showNotification("warning", "", t("you can only send notification to one usergroup"));
    } else {
      let recipient = "";
      if (typeRecipient === "userID") {
        const user_data = users.filter(
          (item) => item.first_name + " " + item.last_name === tag.name,
        )[0];
        recipient = user_data.id;
      } else if (typeRecipient === "userGroup") {
        const usergroup_data = userGroups.filter((item) => item.name === tag.name)[0];
        recipient = usergroup_data.id;
      }
      setRecipients([...recipients, recipient]);
      const newTags = [].concat(tags, tag);
      setTags(newTags);
    }
  };

  //handle click and close schedule button
  const handleToggleShowSchedule = () => {
    setShowSchedule(!showSchedule);
  };

  const handleCloseShowSchedule = () => {
    if (showSchedule === true) {
      setShowSchedule(false);
    }
  };

  const handleToggleScheduleDialog = () => {
    setToggleDialogSchedule(!toggleDialogSchedule);
  };

  const handleChangeSelectDatetime = (date) => {
    setStartDate(date);
  };

  const onDeleteMessage = (message) => {
    // show warning
    if (confirm(t("really_remove"))) {
      props.dispatch(
        messagesActions.deleteMessage({
          id: message.id,
          token: Biscuit.get("token"),
        }),
      );
    }
  };

  useEffect(() => {
    if (_users.success == "") return;

    if (_users.success === true) {
      setUsers([..._users.data]);
    } else {
      console.log("Failed to request users!");
    }
  }, [_users]);

  useEffect(() => {
    if (_userGroups.success == "") return;

    if (_userGroups.success === true) {
      setUserGroups([..._userGroups.data]);
    } else {
      console.log("Failed to request users!");
    }
  }, [_userGroups]);

  useEffect(() => {
    let messagecopy = {};
    Object.assign(messagecopy, message);
    messagecopy.listRecipients = recipients;
    setMessage(messagecopy);
    messagecopy.recipient_type === "userGroup" && recipients.length === 1
      ? setHiddenChooseRecipient(true)
      : setHiddenChooseRecipient(false);
    typeof recipients !== "undefined" && recipients.length > 0 && messagecopy.content
      ? setDisableButtonSend(false)
      : setDisableButtonSend(true);
  }, [recipients]);

  useEffect(() => {
    let messagecopy = {};
    Object.assign(messagecopy, message);
    messagecopy.checkRepeatSchedule = checked;
    setMessage(messagecopy);
  }, [checked]);

  useEffect(() => {
    if (toggleDialogSchedule === false) {
      setFormError({});
      setTimeout(function () {
        initialState = { ...message };
        if (typeof message.id === "undefined") {
          delete initialState.schedule_recurrence;
          delete initialState.schedule_recurrence_number;
          setMessage(initialState);
          setChecked(false);
          setStartDate(new Date());
        } else {
          initialState.schedule_time = new Date("2023-03-24 18:13:03");
          initialState.schedule_recurrence ? (initialState.schedule_recurrence = "year") : "";
          initialState.schedule_recurrence_number
            ? (initialState.schedule_recurrence_number = 4)
            : "";
          setMessage(initialState);
          setStartDate(new Date("2023-03-24 18:13:03"));
          initialState.schedule_recurrence && initialState.schedule_recurrence_number
            ? setChecked(true)
            : setChecked(false);
        }
      }, 800);
    }
  }, [toggleDialogSchedule]);

  useEffect(() => {
    if (_sendMessage.success === "") {
      return;
    }

    if (itemState !== "sending" && itemState !== "scheduling" && itemState !== "saving") return;

    if (_sendMessage.success === true) {
      props.showNotification("success", _sendMessage.data.id, "sent", "message");
      abortButtonRef.current.click();
    } else if (_sendMessage.success === false) {
      const errorMessage = _sendMessage.data[0].error_message;
      setItemState("init");
      props.showNotification("warning", null, errorMessage);
    }
  }, [_sendMessage]);

  useEffect(() => {
    if (_addMessage.success === "") {
      return;
    }

    if (itemState !== "sending" && itemState !== "scheduling" && itemState !== "saving") return;

    if (_addMessage.success == true) {
      props.showNotification("success", _addMessage.data.id, "", "message");
    } else if (_addMessage.success === false) {
      props.showNotification("warning", null, "saved", t("request_error"));
    }
    abortButtonRef.current.click();
  }, [_addMessage]);

  useEffect(() => {
    if (_deleteMessage.success === "") {
      return;
    }
    if (_deleteMessage.success == true) {
      abortButtonRef.current.click();
    } else if (_deleteMessage.success === false) {
      abortButtonRef.current.click();
    }
  }, [_deleteMessage]);

  useEffect(() => {
    if (_editMessage.success === "") {
      return;
    }

    if (itemState !== "saving" && itemState !== "scheduling") return;

    if (_editMessage.success == true) {
      props.showNotification("success", _editMessage.data.id, null, "message");
      abortButtonRef.current.click();
    } else if (_editMessage.success === false) {
      props.showNotification("warning", null, "saved", t("request_error"));
    }
  }, [_editMessage]);

  useEffect(() => {
    const typeRep = message.recipient_type;
    setType(typeRep);
    if (typeRep === "userID") {
      if (users.length > 0) {
        const listSuggestions = users
          .filter((item) => item.id !== undefined)
          .map((item) => {
            return { name: item?.first_name + " " + item?.last_name };
          });
        setSuggestions(listSuggestions);
      }
    } else if (typeRep === "userGroup") {
      if (userGroups.length > 0) {
        const listSuggestions = userGroups
          .filter((item) => item.name !== undefined || item.name !== null)
          .map((item) => {
            return { name: item.name };
          });
        setSuggestions(listSuggestions);
      }
    } else if (typeRep === "allUsers") {
      setRecipients(["all"]);
    }
  }, [users, userGroups]);

  // evaluate form and send message to api
  const onSubmit = (status) => {
    let messagecopy = {};
    Object.assign(messagecopy, message);
    let checkFormError = false;
    let temp = messagecopy.content.replace(/<(.|\n)*?>/g, "");
    messagecopy.content = temp.replaceAll("&nbsp;", " ").replaceAll("&amp;", "&");
    messagecopy.content_for_toast = temp.replaceAll("&nbsp;", " ").replaceAll("&amp;", "&");
    if (messagecopy.content.replace(/<(.|\n)*?>/g, "").trim().length === 0) {
      messagecopy.content = "";
      messagecopy.content_for_toast = "";
    }

    const payload = {
      settings: {
        subject: messagecopy.subject,
        message: messagecopy.content,
        message_toast: messagecopy.content_for_toast,
        notification_type: messagecopy.notification_type,
        ...(props.message !== null &&
          typeof props.message.id !== "undefined" && {
            message_id: messagecopy.message_data[0].message_id,
          }),
      },
      template_type: "",
      type: "push",
    };
    if (messagecopy.recipient_type === "userID") {
      payload.settings.user = recipients;
    } else if (messagecopy.recipient_type === "userGroup") {
      payload.settings.userGroup = recipients;
    } else if (messagecopy.recipient_type === "allUsers") {
      payload.settings.user = "";
      payload.settings.userGroup = "";
    }
    if (toggleDialogSchedule && startDate) {
      payload.settings.schedule_time = startDate;
      messagecopy.schedule_time = startDate;
    }

    if (checked) {
      if (messagecopy.schedule_recurrence_number) {
        payload.settings.schedule_recurrence_number = parseInt(
          messagecopy.schedule_recurrence_number,
        );
      } else {
        payload.settings.schedule_recurrence_number = 1;
      }

      if (messagecopy.schedule_recurrence) {
        payload.settings.schedule_recurrence = messagecopy.schedule_recurrence;
      } else {
        payload.settings.schedule_recurrence = "day";
      }
    }
    try {
      messageSchema.validateSync(messagecopy, {
        abortEarly: false,
      });
      setFormError({});
    } catch (err) {
      const { inner } = err;
      let formErrorCopy = {};

      if (inner && inner[0]) {
        checkFormError = true;
        inner.forEach((error) => {
          const { path, message } = error;

          if (!formErrorCopy[path]) {
            formErrorCopy[path] = message;
          }
        });
      }
      setFormError(formErrorCopy);
    }
    if (!checkFormError) {
      if (typeof message.id !== "undefined" && message.id !== null) {
        if (status === "save") {
          props.dispatch(
            messagesActions.putMessage({
              data: {
                client_id: messagecopy.client_id,
                id: messagecopy.message_data[0].message_id,
                subject: messagecopy.subject,
                notification_type: messagecopy.notification_type,
                recipient:
                  messagecopy.recipient_type === "allUsers" ||
                  messagecopy.recipient_type === "userGroup"
                    ? null
                    : recipients.join(";"),
                user_group_id:
                  messagecopy.recipient_type === "allUsers" ||
                  messagecopy.recipient_type === "userID"
                    ? null
                    : recipients[0],
                message_data: [
                  {
                    id: messagecopy.message_data[0].id,
                    message_id: messagecopy.message_data[0].message_id,
                    m_text: messagecopy.content,
                  },
                ],
              },
              id: message.id,
              token: Biscuit.get("token"),
            }),
          );
          setItemState("saving");
        } else if (status === "sent") {
          props.dispatch(
            messagesActions.sendMessage({
              data: {
                ...payload,
              },
              token: Biscuit.get("token"),
            }),
          );
          setItemState("sending");
        }
        if (status === "save") {
          setItemState("saving");
        } else if (status === "scheduled") {
          setItemState("scheduled");
        }
      } else {
        if (status === "save") {
          const data = {
            client_id: Number(Biscuit.get("user.client_id")),
            subject: messagecopy.subject,
            mtype: "push",
            notification_type: messagecopy.notification_type,
            mstatus: "draft",
            message_data: [
              {
                m_text: messagecopy.content,
              },
            ],
          };
          if (messagecopy.recipient_type === "userID") {
            data.recipient = recipients.join(";");
          } else if (messagecopy.recipient_type === "userGroup") {
            data.user_group_id = recipients[0];
          }
          props.dispatch(
            messagesActions.addMessage({
              data: data,
              token: Biscuit.get("token"),
            }),
          );
          setItemState("saving");
        } else if (status === "sent") {
          props.dispatch(
            messagesActions.sendMessage({
              data: {
                ...payload,
              },
              token: Biscuit.get("token"),
            }),
          );
          setItemState("sending");
        }
      }
    }
  };
  const onChangeMessageEditor = (value) => {
    let clone = {};
    Object.assign(clone, message);
    clone.content = value;
    setMessage(clone);
    try {
      messageSchema.validateSync(clone, {
        abortEarly: false,
      });
      setDisableButtonSend(false);
      clone.content.replace(/<(.|\n)*?>/g, "").trim().length === 0 && setDisableButtonSend(true);
    } catch (err) {
      const { inner } = err;

      if (inner && inner[0]) {
        setDisableButtonSend(true);
      }
    }
  };
  const onChangeForm = (e) => {
    let clone = {};
    Object.assign(clone, message);
    $("#user_item_input_" + e.target.name).css("border-color", "#e3e3e3");
    switch (e.target.name) {
      case "subject":
        clone.subject = e.target.value;
        break;
      case "recipient_type": {
        setTags([]);
        setRecipients([]);
        setHiddenChooseRecipient(false);
        clone.recipient_type = e.target.value;
        break;
      }
      case "notification_type":
        clone.notification_type = e.target.value;
        break;
      case "content":
        clone.content = e.target.value;
        break;
      case "checkRepeatSchedule":
        clone.checkRepeatSchedule = e.target.value;
        break;
      case "schedule_recurrence_number":
        clone.schedule_recurrence_number = e.target.value;
        break;
      case "schedule_recurrence":
        clone.schedule_recurrence = e.target.value;
        break;
    }

    setMessage(clone); // set object state
    try {
      messageSchema.validateSync(clone, {
        abortEarly: false,
      });
      setDisableButtonSend(false);
    } catch (err) {
      const { inner } = err;
      if (inner && inner[0]) {
        setDisableButtonSend(true);
        inner.forEach((error) => {
          const { path, message } = error;
          if (path === "schedule_recurrence" || path === "schedule_recurrence_number") {
            setDisableButtonSend(false);
          }
        });
      }
    }
  };

  useEffect(() => {
    const typeRep = message.recipient_type;
    setSuggestions([]);
    if (typeRep === "allUsers" || typeRep === "userID") {
      props.dispatch(
        userActions.getUsers({
          token: Biscuit.get("token"),
          filter: {
            findForSelect: true,
            find: "short",
            active: 1,
            limit: 999,
            page: 1,
          },
        }),
      );
    } else {
      props.dispatch(
        membershipTypeActions.getMembershipTypes({
          token: Biscuit.get("token"),
          filter: {
            findForSelect: true,
            find: "short",
            active: 1,
            limit: 999,
            page: 1,
          },
        }),
      );
    }
  }, [message.recipient_type]);

  const onInputRecipient = async (query) => {
    const typeRep = message.recipient_type;
    if (typeRep === "allUsers" || typeRep === "userID") {
      await props.dispatch(
        userActions.getUsers({
          token: Biscuit.get("token"),
          filter: {
            findForSelect: true,
            find: "short",
            active: 1,
            limit: 999,
            page: 1,
            q: query,
          },
        }),
      );
    } else {
      await props.dispatch(
        membershipTypeActions.getMembershipTypes({
          token: Biscuit.get("token"),
          filter: {
            findForSelect: true,
            find: "short",
            active: 1,
            limit: 999,
            page: 1,
            n: query,
          },
        }),
      );
    }
  };

  const abortButtonRef = React.createRef();
  let returnUrl =
    typeof props.requestPath !== "undefined"
      ? props.requestPath
      : `/usersExtension/messages${currentUrl.search}`;
  return (
    <>
      <div className="js-off-canvas-overlay is-overlay-fixed is-visible"></div>
      <div
        className={`off-canvas position-right is-transition-overlap is-open message-view__overlay ${isViewMessage ? "is-view-message-screen" : ""} ${hiddenChooseRecipient ? "hide-choose-recipient" : ""}`}
        id="inb-off-canvas"
        data-off-canvas="85mrb3-off-canvas"
        data-close-on-click="false"
        aria-hidden="false"
        onClick={handleCloseShowSchedule}
      >
        <header className="inb-header off-canvas__header off-canvas--shadow row message-header">
          <h1 className="inb-page-title">
            {typeof message.id !== "undefined" && !isViewMessage
              ? t("edit_${a}", { a: t("message", null, "capital") })
              : typeof message.id !== "undefined" && isViewMessage
                ? message.subject
                : t("send_${a}", { a: t("message", null, "capital") })}
          </h1>
          <div className="off-canvas__actions message-actions">
            {!isViewMessage && (
              <div className="button-actions" style={{ display: "flex" }}>
                {/* <div role="group" className="dropdown btn-group round"> */}
                <button
                  type="submit"
                  className={
                    "button button-" + Biscuit.get("user.client_id") + " medium button-send round"
                  }
                  disabled={itemState === "sending" || itemState === "saving"}
                  data-testid="button-send"
                  title={t("send", null, "capital")}
                  onClick={() => onSubmit("sent")}
                >
                  {itemState != "sending" && <span>{t("send")}</span>}
                  {itemState == "sending" && (
                    <span>
                      <img className="rollingLoader" src="assets/img/rolling_loader.svg" />
                      {t("send")}
                    </span>
                  )}
                </button>
                {/* <button type="button" className={"button button-" + Biscuit.get('user.client_id') + " dropdown-split round"} data-testid="button-dropdown-split" disabled={disableButtonSend || itemState === "sending" || itemState === 'saving'} title={t('schedule for later',null,'capital')} onClick={handleToggleShowSchedule}>
                                <FontAwesomeIcon icon={faSortDown} aria-controls="show-schedule" aria-haspopup="true"/>
                            </button>
                                {showSchedule &&
                                    <ul className="menu-dropdown" onClick={handleToggleScheduleDialog}>
                                        <li>
                                            <FontAwesomeIcon icon={faPaperPlane} style={{  marginRight: "5px" }} />
                                            <div>{t('schedule send')}</div>
                                        </li>
                                    </ul>
                                } */}
                {/* </div> */}
                <button
                  type="submit"
                  className={
                    "button medium beautify beautify-" +
                    Biscuit.get("user.client_id") +
                    " button-draft round"
                  }
                  disabled={itemState === "sending" || itemState === "saving"}
                  data-testid="button-draft"
                  title={t("save", null, "capital")}
                  onClick={() => onSubmit("save")}
                >
                  {itemState != "saving" && <span>{t("save")}</span>}
                  {itemState == "saving" && (
                    <span>
                      <img className="rollingLoader" src="assets/img/rolling_loader.svg" />
                      {t("save")}
                    </span>
                  )}
                </button>
              </div>
            )}
            <div className="icon-actions" style={{ display: "flex" }}>
              {typeof message.id !== "undefined" && !isViewMessage && (
                <a>
                  <button
                    style={{ marginRight: "20px" }}
                    type="button"
                    id="inb-message-delete-button"
                    data-testid="message-detele-button"
                    className="button hollow secondary right button-delete round"
                    title="Delete Message"
                    onClick={() => onDeleteMessage(message)}
                  >
                    <i className="fi fi-trash"></i>
                  </button>
                </a>
              )}
              <a href={returnUrl} style={{ display: "inline-block" }}>
                <button
                  ref={abortButtonRef}
                  type="button"
                  id="inb-message-abort-button"
                  data-testid="message-abort-button"
                  className="button hollow secondary right button-abort round"
                  title="Fenster schließen"
                >
                  <i className="fi fi-x"></i>
                </button>
              </a>
            </div>
          </div>
        </header>
        <ScheduleDialog
          handleToggleScheduleDialog={handleToggleScheduleDialog}
          handleChangeCheckRepeat={handleChangeCheckRepeat}
          handleChangeSelectDatetime={handleChangeSelectDatetime}
          onChangeForm={onChangeForm}
          toggleDialogSchedule={toggleDialogSchedule}
          onSubmit={onSubmit}
          formError={formError}
          message={message}
          itemState={itemState}
          startDate={startDate}
          checked={checked}
        />
        <form className="off-content row message-form">
          <UserInput
            value={{ name: "subject", display_name: t("subject") }}
            val={message.subject}
            name={"subject"}
            module="message"
            mediumWidth="12"
            placeholder="enter a subject"
            onChangeForm={onChangeForm}
            formError={formError}
            disabled={isViewMessage}
            type="matrixField"
          />
          {(!isViewMessage || message.mtype !== "email") && (
            <>
              <div className="large-5 medium-4 small-12 type_recipient_container">
                <UserInput
                  value={{ name: "type-recipient", display_name: t("type") }}
                  mediumWidth="12"
                  name={"recipient_type"}
                  val={message.recipient_type}
                  module="message"
                  getAvailableTypeRecipient={props.getAvailableTypeRecipient}
                  onChangeForm={onChangeForm}
                  formError={formError}
                  disabled={isViewMessage}
                  type="extraField"
                  style={{ marginRight: "220px" }}
                />
                <span className="help-text small-12">
                  {typeof formError["recipient_type"] !== "undefined"
                    ? t(formError["recipient_type"])
                    : ""}
                </span>
              </div>
              <div className="inb-form-group column large-1 medium-3 small-12 hidden_block"></div>
              <div className="large-5 medium-4 small-12 type_notification_container">
                <UserInput
                  value={{ name: "type-notification", display_name: t("display") }}
                  mediumWidth="12"
                  val={message.notification_type}
                  name={"notification_type"}
                  module="message"
                  getAvailableTypeNotification={props.getAvailableTypeNotification}
                  onChangeForm={onChangeForm}
                  formError={formError}
                  disabled={isViewMessage}
                  type="extraField"
                />
                <span className="help-text small-12">
                  {typeof formError["notification_type"] !== "undefined"
                    ? t(formError["notification_type"])
                    : ""}
                </span>
              </div>
            </>
          )}
          {message.recipient_type !== "allUsers" && (
            <div
              className={`inb-form-group column medium-12 small-12 to`}
              style={{ marginBottom: "20px" }}
            >
              <label className="inb-form__controlLabel">{t("to")}</label>
              {/*<ReactTags
                                ref={reactTags}
                                tags={tags}
                                name='listRecipients'
                                suggestions={suggestions}
                                placeholderText={t("choose recipients...")}
                                removeButtonText={t("click to remove this recipient")}
                                allowNew
                                minQueryLength = {1}
                                onInput = {onInputRecipient}
                                maxSuggestionsLength={999}
                                autoresize = {false}
                                onDelete={handleDeleteRecipient}
                                onAddition={handleAdditionRecipient}
                            />*/}
              {type === "userID" && (
                <div id="quick-order-form__user-select-container">
                  <InboomaSelectBox
                    sortBy="created"
                    sortDirection="desc"
                    advanced={true}
                    placeholder={t("choose recipients...")}
                    selectedItems={tags}
                    selectField="name"
                    setSelectedItems={setTags}
                    onSelectItem={handleAdditionRecipient}
                    dispatch={props.dispatch}
                    container="order-vcard"
                    multiSelect={true}
                    extraStyle={{ width: "750px" }}
                    onReset={handleDeleteRecipient}
                  />
                  <div id="order-vcard" className=""></div>
                </div>
              )}
              {type === "userGroup" && (
                <ReactTags
                  ref={reactTags}
                  tags={tags}
                  name="listRecipients"
                  suggestions={suggestions}
                  placeholderText={t("choose recipients...")}
                  removeButtonText={t("click to remove this recipient")}
                  allowNew
                  minQueryLength={1}
                  onInput={onInputRecipient}
                  maxSuggestionsLength={999}
                  autoresize={false}
                  onDelete={handleDeleteRecipient}
                  onAddition={handleAdditionRecipient}
                />
              )}
              <span className="help-text">
                {typeof formError.listRecipients !== "undefined" ? t(formError.listRecipients) : ""}
              </span>
            </div>
          )}
          <div
            className="inb-form-group column medium-12 small-12 content"
            style={{ marginTop: "25px" }}
          >
            {isViewMessage ? (
              <div
                className="message-content"
                dangerouslySetInnerHTML={{ __html: message.content }}
              ></div>
            ) : (
              <Editor
                onChangeForm={onChangeMessageEditor}
                value={message.content}
                readOnly={isViewMessage}
              />
            )}
            <span className="help-text">{t(formError.content)}</span>
          </div>
        </form>
      </div>
    </>
  );
};

export default MessageView;
